"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _list = _interopRequireDefault(require("../user/list"));
var _staff = require("@/api/staff");
var _toolsValidate = require("@/utils/toolsValidate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var editPram = {
  idPhoto: null,
  name: null,
  userId: null,
  phone: null,
  status: 1,
  sort: 0,
  id: null,
  nickName: null,
  avatar: null
};
var _default2 = exports.default = {
  components: {
    userList: _list.default
  },
  props: {
    editDialogConfig: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      selectedRow: null,
      userVisible: false,
      editPram: Object.assign({}, editPram),
      rules: {
        idPhoto: [{
          required: true,
          message: '请设置头像',
          trigger: 'change'
        }],
        avatar: [{
          required: true,
          message: '请关联用户',
          trigger: 'change'
        }],
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'change'
        }],
        phone: [{
          required: true,
          validator: _toolsValidate.validatePhone,
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    editDialogConfig: {
      handler: function handler(nVal, oVal) {
        this.init();
      },
      deep: true
    }
  },
  created: function created() {},
  methods: {
    // 选择用户
    handlerChangeUser: function handlerChangeUser() {
      if (this.editDialogConfig.isCreate === 0) this.userVisible = true;
    },
    init: function init() {
      if (this.editDialogConfig.isCreate == 1) {
        for (var key in this.editDialogConfig.data) {
          this.editPram[key] = this.editDialogConfig.data[key];
        }
      } else {
        this.editPram = Object.assign({}, editPram);
      }
    },
    close: function close() {
      this.userVisible = false;
    },
    getUser: function getUser() {
      this.editPram.avatar = this.selectedRow.avatar;
      this.editPram.userId = this.selectedRow.uid;
      this.editPram.nickName = this.selectedRow.nickname;
      this.userVisible = false;
    },
    getRow: function getRow(row) {
      this.selectedRow = row;
      this.getUser();
    },
    //取消
    handlerClose: function handlerClose() {
      this.$emit('hideEditDialog', 0);
    },
    //表单确认
    handlerSubmit: function handlerSubmit() {
      var _this2 = this;
      this.$refs.editPram.validate(function (valid) {
        if (!valid) return;
        if (_this2.editDialogConfig.isCreate == 0) {
          (0, _staff.serviceStaffAddApi)(_this2.editPram).then(function (res) {
            _this2.$emit('hideEditDialog', 1, 0);
          });
        } else {
          (0, _staff.serviceStaffUpdateApi)(_this2.editPram).then(function (res) {
            _this2.$emit('hideEditDialog', 1, 1);
          });
        }
      });
    },
    //点击头像
    modalPicTap: function modalPicTap(tit, num, i) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        if (!tit && !num) {
          _this.editPram.idPhoto = img[0].sattDir;
        }
      }, tit, 'store');
    }
  }
};